// extracted by mini-css-extract-plugin
export default {"title":"J8-z","warning":"K8-z","sizeOptionsLegendText":"L8-z"};